<template>
  <div class="home-index">
    <div class="top box" v-if="news_panel">
      <div>
        <Icon type="md-volume-up" />
      </div>
      <div class="main">
        <span>
          <a
            target="_blank"
            :href="news_panel.panel_data[0].url"
            class="demo-badge"
          >{{news_panel.panel_data[0].title}}</a>
        </span>
        <span></span>
      </div>
      <div>
        <a target="_blank" :href="news_panel.more_url">更多</a>
      </div>
    </div>
    <div class="details box">
      <h3>账号整体情况</h3>
      <ul>
        <li>
          <p class="name">
            <Icon type="ios-home" />
            <span>进驻商家</span>
          </p>
          <p class="number">
            <router-link to="/store_list">{{info.business_count}}</router-link>
          </p>
        </li>
        <li>
          <p class="name">
            <Icon type="md-cash" />
            <span>总流水</span>
          </p>
          <p class="number">
            <router-link to="/finance_report">￥{{info.all_income}}</router-link>
          </p>
        </li>
        <li>
          <p class="name">
            <Icon type="ios-card" />
            <span>代理收益</span>
          </p>
          <p class="number">
            <router-link to="/finance_report">￥{{info.all_gain}}</router-link>
          </p>
        </li>
      </ul>
      <Spin size="large" fix v-if="spinShow2"></Spin>
    </div>
    <div class="listbox box">
      <h3>最近活动</h3>
      <div class="list">
        <ul>
          <li v-for="(item,index) in list" :key="index">
            <div
              class="img-content"
              :style="{backgroundImage: 'url('+item.pic+')',backgroundRepeat:'no-repeat',backgroundSize:'100% 100%'}"
            >
              <div class="qr">
                <img :src="item.base64" />
              </div>
            </div>
            <div class="listbox-content">
              <div class="name">
                <Tag color="default">{{getClassify(item.type)}}</Tag>
                <a @click="listCk(item.link)">{{item.title}}</a>
              </div>
              <div class="merchant">
                来自：
                <router-link :to="{name:'StoreList',params:{name:item.username}}">{{item.username}}</router-link>
              </div>
              <div class="time">{{getMoment(item.create_time*1000)}}</div>
            </div>
          </li>
        </ul>
        <Spin size="large" fix v-if="spinShow"></Spin>
      </div>
      <Page :current="page" :total="count" simple @on-change="change" />
      <div class="qr-fixed" v-show="qrShow" @click="qrShow=false">
        <img :src="base64" />
      </div>
    </div>
  </div>
</template>

<script>
console.log(document)
import QRCode from "qrcode";
import {
  pageContent,
  getAccountCollect,
  getLatePartyUnionLists
} from "@/service/api.js";
export default {
  data() {
    return {
      info: {},
      list: [],
      page: 1,
      count: 0,
      news_panel: null,
      base64: "",
      qrShow: false,
      spinShow: false,
      spinShow2: false
    };
  },
  created() {
    this.spinShow2 = true;
    getAccountCollect().then(res => {
      console.log(res.data);
      if(res.data.code == 0){
        this.info = res.data.data;
        this.spinShow2 = false;
      }
    });
    pageContent().then(res => {
      if(res.data.code == 0){
        let data = res.data.data;
        this.news_panel = data.body.news_panel;
        console.log(this.news_panel);
      }
    });
    this.getLatePartyUnionLists(this.page);
  },
  methods: {
    //生成二维码
    getQRCode(data) {
      let img;
      QRCode.toDataURL(data, { errorCorrectionLevel: "M" }, (err, url) => {
        if (!err) {
          img = url;
        } else {
          console.log("生成二维码失败");
        }
      });
      return img;
    },
    getLatePartyUnionLists(page) {
      this.spinShow = true;
      getLatePartyUnionLists({
        page: page,
        limit: 10
      }).then(res => {
        if(res.data.code == 0){
          this.count = res.data.data.count;
          this.list.splice(0);
          scrollTo(0,0);
          for (let item in res.data.data.list) {
            res.data.data.list[item].base64 = this.getQRCode(
              res.data.data.list[item].link
            );
            this.list.push(res.data.data.list[item]);
          }
          this.page = page;
          this.spinShow = false;
        }
      });
    },
    getMoment(key) {
      return this.$moment(key).format("YYYY-MM-DD HH:mm:ss");
    },
    getClassify(data) {
      let type = "";
      switch (data) {
        case "vote":
          type = "投票";
          break;
        case "grade":
          type = "评分";
          break;
        case "live":
          type = "直播";
          break;
      }
      return type;
    },
    listCk(link) {
      // window.open(link)
      this.base64 = this.getQRCode(link);
      this.qrShow = true;
    },
    change(page) {
      console.log(page);
      this.getLatePartyUnionLists(page);
    }
  }
};
</script>

<style lang="less" scoped>
.empty {
  text-align: center;
  padding: 20px 0;
}
.home-index {
  // width: 90%;
  width: 100%;
  margin: 0 auto;
  padding: 30px 30px 30px 0;
  .top {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    // color: #353535;
    color: #9a9a9a;
    a {
      color: #9a9a9a;
    }
    .ivu-icon {
      font-size: 20px;
    }
    .main {
      margin: 0 20px 0 10px;
      flex: 1;
      display: flex;
      justify-content: space-between;
    }
  }
  .details {
    width: 100%;
    position: relative;
    ul {
      padding: 50px 30px 30px;
      display: flex;
      justify-content: space-around;
    }
    li {
      flex: 1;
      text-align: center;
      .name {
        color: #9a9a9a;
        .ivu-icon {
          font-size: 26px;
          margin-right: 6px;
          vertical-align: middle;
        }
      }
      .number {
        font-size: 36px;
        font-weight: 600;
        margin: 30px auto;
      }
    }
  }
  .listbox {
    .qr-fixed {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 300px;
        height: 300px;
      }
    }
    .list {
      position: relative;
      ul {
        margin-top: 30px;
        li {
          display: flex;
          margin-bottom: 30px;
          .img-content {
            width: 250px;
            height: 150px;
            background: rgb(0, 0, 0);
            &:hover {
              .qr {
                display: block;
              }
            }
            .qr {
              width: 100%;
              height: 100%;
              background: rgba(0, 0, 0, 0.5);
              display: none;
              position: relative;
              img {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                width: 100px;
                height: 100px;
              }
            }
          }
          .listbox-content {
            width: 600px;
            padding: 6px 20px;
            display: flex;
            flex-direction: column;
            a {
              // margin-left: 6px;
              color: #464646;
            }
            .name {
              font-size: 16px;
              font-weight: 800;
            }
            .merchant {
              flex: 1;
              margin-top: 6px;
              margin-left: 10px;
            }
            .time {
              margin-left: 6px;
              color: #9a9a9a;
            }
          }
        }
      }
    }
  }
}
.box {
  margin-bottom: 30px;
  background-color: #ffffff;
  border-radius: 3px;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.05);
  padding: 30px 40px;
}
</style>